import {
  FETCH_SMARTCHATAI_REPORT_CHAT_TOPICS,
  FETCH_SMARTCHATAI_REPORT_CHAT_TOPICS_FAILURE,
  FETCH_SMARTCHATAI_REPORT_CHAT_TOPICS_SUCCESS,
  FETCH_SMARTCHATAI_REPORT_DATA,
  FETCH_SMARTCHATAI_REPORT_DATA_FAILURE,
  FETCH_SMARTCHATAI_REPORT_DATA_SUCCESS,
} from '../actions';

const initialState = {
  reportData: {
    loading: false,
    data: [],
    pagination: {
      page: 1,
      limit: 10,
      total: 0,
      totalPages: 0,
    },
    error: null,
  },
  chatTopics: {
    loading: false,
    data: [],
    error: null
  }
};

export function smartChatAI(state = initialState, action) {
  switch (action.type) {
    case FETCH_SMARTCHATAI_REPORT_DATA:
      return {
        ...state,
        reportData: {
          ...state.reportData,
          loading: true,
          error: null,
        },
      };
    case FETCH_SMARTCHATAI_REPORT_DATA_SUCCESS:
      return {
        ...state,
        reportData: {
          ...state.reportData,
          data: action.payload?.data,
          pagination: {
            page: action.payload?.page,
            limit: action.payload?.limit,
            total: action.payload?.total,
            totalPages: action.payload?.totalPages,
          },
          loading: false,
          error: null,
        },
      };
    case FETCH_SMARTCHATAI_REPORT_DATA_FAILURE:
      return {
        ...state,
        reportData: {
          ...state.reportData,
          loading: false,
          error: action.error,
        },
      };

      case FETCH_SMARTCHATAI_REPORT_CHAT_TOPICS:
      return {
        ...state,
        chatTopics: {
          ...state.chatTopics,
          loading: true,
          error: null,
        },
      };
    case FETCH_SMARTCHATAI_REPORT_CHAT_TOPICS_SUCCESS:
      return {
        ...state,
        chatTopics: {
          ...state.chatTopics,
          data: action.payload?.data,
          loading: false,
          error: null,
        },
      };
    case FETCH_SMARTCHATAI_REPORT_CHAT_TOPICS_FAILURE:
      return {
        ...state,
        chatTopics: {
          ...state.chatTopics,
          loading: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
}
